import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CHAT_STRINGS_PT, ChatStrings } from '../../chat.strings';
import { ChatVisitParams } from '../../chat.model';
import { formatWhen } from '../../chat.format';
import { ChatIconName } from '../chat-icon/chat-icon.component';

/**
 * `kind: 'visit'` (7.2): a visita marcada no CRM, com o estado lido da própria
 * visita (marcada, realizada, cancelada). Ações do staff (`canManage`):
 * cancelar (com motivo) e pedir a avaliação; para todos, "adicionar ao
 * calendário" (.ics gerado no cliente).
 */
@Component({
  selector: 'chat-visit-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './chat-visit-card.component.html',
  styleUrls: ['./chat-visit-card.component.css']
})
export class ChatVisitCardComponent implements OnChanges {
  @Input() params: Partial<ChatVisitParams> = {};
  @Input() canManage = false;
  @Input() strings: ChatStrings = CHAT_STRINGS_PT;
  @Output() cancel = new EventEmitter<void>();
  @Output() ics = new EventEmitter<void>();
  @Output() requestForm = new EventEmitter<void>();
  /** Secção 11: novo horário para uma visita ainda marcada. */
  @Output() reschedule = new EventEmitter<void>();

  when = '';
  statusText = '';
  /** Reagendada: o horário anterior, para se perceber o que mudou. */
  previousWhen = '';
  tone: 'ok' | 'done' | 'off' = 'ok';
  icon: ChatIconName = 'check';

  ngOnChanges(): void {
    const p = this.params || {};
    this.when = formatWhen(p.startAt);
    this.previousWhen = p.rescheduledAt && p.previousStartAt && p.previousStartAt !== p.startAt ? formatWhen(p.previousStartAt) : '';
    const status = p.status || 'SCHEDULED';
    this.statusText = status === 'SCHEDULED' && p.rescheduledAt ? this.strings.visitRescheduled : (this.strings.visitStatus[status] || status);
    this.tone = status === 'CANCELED' ? 'off' : status === 'DONE' ? 'done' : 'ok';
    this.icon = status === 'CANCELED' ? 'close' : status === 'DONE' ? 'check2' : 'check';
  }

  get scheduled(): boolean {
    return (this.params && this.params.status) === 'SCHEDULED' || !(this.params && this.params.status);
  }

  /** A avaliação só se pede depois de a visita ter acontecido (realizada, ou marcada e já passada). */
  get evaluable(): boolean {
    const p = this.params || {};
    if (p.status === 'DONE') {
      return true;
    }
    if (p.status === 'CANCELED') {
      return false;
    }
    const at = p.startAt ? new Date(p.startAt).getTime() : NaN;
    return !isNaN(at) && at < Date.now();
  }
}
